/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.vip.ts
 *
 * Messages de l'ACCÈS VIP (décisions de Mika du 2026-10-05) : vérification
 * du lien personnel par un code reçu par courriel, accueil VIP (identité,
 * photo, venue, accompagnant, badge, installation, visite guidée), et
 * écran d'administration des invitations. Fusionné dans fr.ts.
 *
 * Générique : le nom de l'événement, sa date et son lieu viennent des jetons
 * d'identité ({eventName}, {eventDateLong}, {eventPlace}) ; le vocabulaire du
 * métier vient des jetons de lexique ({lexExhibitorPlural}...).
 *
 * Mikael - chef de projet - 2026-10-05
 */
export const messagesVipFr: Record<string, string> = {
  // ── Vérification du lien (/vip/acces) ─────────────────────────────────
  'vip.acces.surtitre': 'Accès VIP',
  'vip.acces.titre': 'Vérification de votre accès VIP',
  'vip.acces.titreAncienLien': 'Invitation VIP',
  // 2026-10-06 : le code ne part qu'au toucher du bouton (les antivirus de
  // messagerie ouvrent les liens). Mikael - chef de projet - 2026-10-06
  'vip.acces.accueil':
    'Pour votre sécurité, un code à 6 chiffres va vous être envoyé à l’adresse de votre invitation. Touchez le bouton pour le recevoir.',
  'vip.acces.recevoir': 'Recevoir mon code',
  'vip.acces.envoiEnCours': 'Envoi du code…',
  'vip.acces.envoye': 'Pour votre sécurité, nous venons d’envoyer un code à 6 chiffres à {email}.',
  'vip.acces.dejaEnvoye': 'Un code vous a été envoyé il y a quelques instants à {email}. Saisissez-le ci-dessous.',
  'vip.acces.app': 'Saisissez le code affiché par votre application d’authentification.',
  'vip.acces.appCourriel': 'Recevoir plutôt un code par courriel',
  'vip.acces.code.label': 'Code de sécurité',
  'vip.acces.code.aide': 'Six chiffres, reçus par courriel.',
  'vip.acces.valider': 'Ouvrir mon accès',
  'vip.acces.renvoyer': 'Recevoir un nouveau code',
  'vip.acces.renvoye': 'Un nouveau code vient de partir.',
  'vip.acces.pourquoi':
    'Cette vérification protège votre accès : elle est demandée une seule fois sur chaque nouvel appareil.',
  'vip.acces.erreur.code': 'Ce code n’est pas le bon, ou il a expiré. Vérifiez le dernier courriel reçu.',
  'vip.acces.erreur.reseau': 'La connexion a échoué. Vérifiez votre réseau et réessayez.',
  'vip.acces.erreur.titre': 'Ce lien ne peut pas être utilisé',
  'vip.acces.erreur.invalide':
    'Ce lien d’accès n’est pas reconnu. Ouvrez de nouveau le bouton de votre courriel d’invitation.',
  'vip.acces.erreur.expire':
    'Ce lien d’accès a expiré. Demandez-en un nouveau à l’organisation : il vous sera envoyé aussitôt.',
  'vip.acces.erreur.revoque':
    'Cette invitation n’est plus active. Si vous pensez qu’il s’agit d’une erreur, écrivez à l’organisation.',
  'vip.acces.erreur.trop': 'Trop d’essais rapprochés. Patientez quelques minutes, puis réessayez.',
  'vip.acces.erreur.patienter': 'Un code vient de partir. Patientez une minute avant d’en demander un nouveau.',
  'vip.acces.erreur.renouveler':
    'Par sécurité, les codes envoyés ont été annulés après plusieurs essais incorrects. Demandez un nouveau code.',
  'vip.acces.contact': 'Écrire à l’organisation',
  'vip.acces.autreAppareil': 'Accès VIP depuis cet appareil',
  'vip.acces.sansLien': 'Ce lien est incomplet. Ouvrez de nouveau le bouton de votre courriel d’invitation.',

  // ── Nouvel appareil (/vip/connexion) ──────────────────────────────────
  'vip.connexion.titre': 'Accès VIP',
  'vip.connexion.texte':
    'Pour protéger votre accès, chaque nouvel appareil est vérifié une seule fois : saisissez l’adresse à laquelle vous avez reçu votre invitation, puis le code à 6 chiffres envoyé par courriel.',
  'vip.connexion.continuer': 'Continuer',
  'vip.connexion.retour': 'Vous n’êtes pas invité VIP ? Revenir à l’accueil',

  // ── Accueil VIP (/vip) ────────────────────────────────────────────────
  'vip.accueil.surtitre': 'Accès VIP',
  'vip.accueil.titrePage': 'Accueil VIP',
  'vip.accueil.bienvenue': 'Bienvenue, {nom}',
  'vip.accueil.intro': 'Merci de votre venue à {eventName}. Quelques instants suffisent pour préparer votre accueil.',
  'vip.accueil.quand': '{eventDateLong} · {eventPlace}',
  'vip.accueil.progression': '{faites} étapes sur {total}',
  'vip.accueil.chargement': 'Préparation de votre accueil…',
  'vip.accueil.erreur': 'Votre accueil n’a pas pu s’afficher. Réessayez dans un instant.',
  'vip.accueil.reessayer': 'Réessayer',
  'vip.accueil.toutFait': 'Tout est prêt. Au plaisir de vous accueillir.',
  'vip.accueil.etapeFaite': 'Étape terminée',

  'vip.identite.titre': 'Vos informations',
  'vip.identite.texte': 'Vérifiez votre titre et votre institution : ils figureront sur votre badge.',
  'vip.identite.civilite': 'Civilité',
  'vip.identite.civilite.aucune': 'Non précisée',
  'vip.identite.civilite.madame': 'Madame',
  'vip.identite.civilite.monsieur': 'Monsieur',
  'vip.identite.prenom': 'Prénom',
  'vip.identite.nom': 'Nom',
  'vip.identite.fonction': 'Titre ou fonction',
  'vip.identite.institution': 'Institution',
  'vip.identite.nonRenseigne': 'Non renseigné',
  'vip.identite.exact': 'C’est exact',
  'vip.identite.modifier': 'Modifier',
  'vip.identite.enregistrer': 'Enregistrer',
  'vip.identite.annuler': 'Annuler',

  'vip.photo.titre': 'Votre photo',
  'vip.photo.texte': 'Facultative : elle apparaîtra sur votre badge VIP.',
  'vip.photo.choisir': 'Choisir une photo',
  'vip.photo.changer': 'Changer de photo',
  'vip.photo.passer': 'Continuer sans photo',
  'vip.photo.enCours': 'Envoi de la photo…',
  'vip.photo.ok': 'Photo enregistrée.',
  'vip.photo.erreur': 'La photo n’a pas pu être enregistrée (JPEG ou PNG, 5 Mo au plus).',
  'vip.photo.alt': 'Votre photo',
  'vip.photo.continuer': 'Continuer',

  'vip.venue.titre': 'Votre venue',
  'vip.venue.question': 'Confirmez-vous votre venue ?',
  'vip.venue.oui': 'Oui, je serai là',
  'vip.venue.non': 'Je ne pourrai pas venir',
  'vip.venue.accompagne': 'Une personne m’accompagnera',
  'vip.venue.accompagnant': 'La personne qui vous accompagne',
  'vip.venue.accompagnantAide': 'Elle recevra elle aussi un badge VIP.',
  'vip.venue.erreur.prenom': 'Indiquez son prénom.',
  'vip.venue.erreur.nom': 'Indiquez son nom.',
  'vip.venue.confirmer': 'Confirmer ma venue',
  'vip.venue.merciOui': 'Merci, votre venue est confirmée.',
  'vip.venue.merciNon': 'C’est noté. Merci de nous avoir prévenus.',
  'vip.venue.avec': 'Avec {nom}.',
  'vip.venue.modifier': 'Modifier ma réponse',
  'vip.venue.badge': 'Télécharger mon badge',
  'vip.venue.badgeAccueil': 'Votre badge vous attendra aussi à l’accueil.',
  'vip.venue.apercu': 'Aperçu de votre badge',
  'vip.venue.erreur': 'Votre réponse n’a pas pu être enregistrée. Réessayez dans un instant.',

  'vip.installer.titre': 'L’application sur votre téléphone',
  'vip.installer.texte': 'Gardez l’événement dans votre poche : programme, plan et informations en direct.',
  'vip.installer.android': 'Installer l’application',
  'vip.installer.installee': 'L’application est installée sur cet appareil.',
  'vip.installer.ios': 'Sur iPhone, deux gestes suffisent :',
  'vip.installer.ios1': 'Touchez le bouton Partager en bas de Safari, puis « Sur l’écran d’accueil ».',
  'vip.installer.ios2': 'Touchez « Ajouter » en haut à droite.',
  'vip.installer.iosApres':
    'Ouvrez ensuite l’application installée et touchez « Accès VIP » : un code de sécurité vous sera envoyé par courriel, une seule fois pour cet appareil.',
  'vip.installer.ordinateur':
    'Sur ordinateur, scannez le code QR de votre courriel d’invitation avec votre téléphone : l’application s’y installera.',
  'vip.installer.fait': 'C’est fait',
  'vip.installer.plusTard': 'Plus tard',
  'vip.installer.alt1': 'Le menu Partager de Safari et son option « Sur l’écran d’accueil »',
  'vip.installer.alt2': 'Le bouton « Ajouter »',

  'vip.decouvrir.titre': 'Découvrir l’application',
  'vip.decouvrir.texte': 'Une courte visite de ce que nous avons mis en place.',
  'vip.decouvrir.lancer': 'Commencer la visite',
  'vip.decouvrir.revoir': 'Revoir la visite',
  'vip.decouvrir.libre': 'Explorer librement',

  // ── Visite guidée ─────────────────────────────────────────────────────
  'vip.visite.titre': 'Visite guidée',
  'vip.visite.position': 'Écran {n} sur {total}',
  'vip.visite.suivant': 'Suivant',
  'vip.visite.precedent': 'Précédent',
  'vip.visite.terminer': 'Explorer l’application',
  'vip.visite.fermer': 'Fermer la visite',
  'vip.visite.evenement.titre': '{eventTypeDefCap} en un coup d’œil',
  'vip.visite.evenement.texte':
    'Les {lexExhibitorPlural} présents, leur emplacement sur le plan et le programme des {lexWorkshopPlural}, à jour en direct.',
  'vip.visite.offres.titre': 'Les offres',
  'vip.visite.offres.texte':
    'Chaque {lexExhibitorBare} publie ses offres d’emploi, d’alternance et de stage. Les candidats les consultent et postulent depuis leur téléphone.',
  'vip.visite.cv.titre': 'Le CV et ses conseils',
  'vip.visite.cv.texte':
    'Les candidats déposent leur CV avant, pendant et après l’événement, et reçoivent des conseils concrets pour l’améliorer.',
  'vip.visite.scan.titre': 'Le scan des badges',
  'vip.visite.scan.texte':
    'Les {lexExhibitorPlural} scannent le badge des candidats rencontrés : chaque rencontre est retrouvée, aucune ne se perd.',
  'vip.visite.ia.titre': 'Une intelligence artificielle encadrée',
  'vip.visite.ia.texte':
    'Des suggestions utiles (offres, rencontres, conseils), encadrées par des règles claires : chacun garde toujours la main.',
  'vip.visite.pilotage.titre': 'Le pilotage en direct',
  'vip.visite.pilotage.texte':
    'L’équipe d’organisation suit la fréquentation et les rencontres en temps réel, et ajuste l’accueil au fil de la journée.',

  // ── Raccourcis ────────────────────────────────────────────────────────
  'vip.plus.lien': 'Mon accueil VIP',
  'vip.home.acces': 'Accès VIP',
  'vip.home.accesAide': 'Vous avez reçu une invitation VIP ?',

  // ── Back-office : invitations VIP ─────────────────────────────────────
  'vipAdmin.titre': 'Invitations VIP',
  'vipAdmin.sousTitre':
    'Chaque invité reçoit un courriel avec un bouton et un code QR. Son lien ouvre une vérification par code envoyé à son adresse : il n’a ni compte à créer, ni mot de passe.',
  'vipAdmin.migration':
    'La migration V149 n’est pas appliquée sur cette instance : le suivi (venue, accompagnant, connexions) est indisponible.',
  'vipAdmin.nouvelle': 'Nouvelle invitation',
  'vipAdmin.champ.civilite': 'Civilité (facultative)',
  'vipAdmin.champ.prenom': 'Prénom',
  'vipAdmin.champ.nom': 'Nom',
  'vipAdmin.champ.email': 'Adresse de courriel',
  'vipAdmin.champ.titre': 'Titre ou fonction',
  'vipAdmin.champ.institution': 'Institution',
  'vipAdmin.envoyer': 'Envoyer l’invitation',
  'vipAdmin.envoye': 'Invitation envoyée à {nom}.',
  'vipAdmin.envoyeSansCourriel':
    'Invitation créée, mais le courriel n’est pas parti. Lien personnel à transmettre : {lien}',
  'vipAdmin.erreur': 'L’opération n’a pas abouti.',
  'vipAdmin.apercu.titre': 'Voir le courriel avant de l’envoyer',
  'vipAdmin.apercu.aide':
    'Le courriel réel, avec les informations saisies ci-dessus (ou celles d’un invité de la liste), et un lien sans valeur : personne d’autre ne reçoit rien.',
  'vipAdmin.apercu.adresse': 'Adresse qui recevra l’aperçu',
  'vipAdmin.apercu.envoyer': 'Envoyer un aperçu',
  'vipAdmin.apercu.ok': 'Aperçu envoyé à {email}.',
  'vipAdmin.liste': 'Suivi des invités',
  'vipAdmin.filtre': 'Afficher',
  'vipAdmin.filtre.tous': 'Tous',
  'vipAdmin.recherche': 'Rechercher un nom, une institution',
  'vipAdmin.suivi.invite': 'Invité, lien non ouvert',
  'vipAdmin.suivi.ouvert': 'Lien ouvert',
  'vipAdmin.suivi.confirme': 'Venue confirmée',
  'vipAdmin.suivi.decline': 'Venue déclinée',
  'vipAdmin.suivi.revoque': 'Révoquée',
  'vipAdmin.suivi.expire': 'Lien expiré',
  'vipAdmin.kpi.total': 'Invités',
  'vipAdmin.kpi.confirme': 'Confirmés',
  'vipAdmin.kpi.accompagnants': 'Accompagnants',
  'vipAdmin.kpi.attendus': 'Personnes attendues',
  'vipAdmin.kpi.decline': 'Déclinés',
  'vipAdmin.kpi.attente': 'Sans réponse',
  'vipAdmin.vide': 'Aucune invitation pour le moment.',
  'vipAdmin.aucunResultat': 'Aucun invité ne correspond.',
  'vipAdmin.avec': 'Accompagné de {nom}',
  'vipAdmin.connexion': 'Dernière connexion : {date}',
  'vipAdmin.jamaisConnecte': 'Jamais connecté',
  'vipAdmin.envoiCompte': '{n, plural, one {# courriel envoyé} other {# courriels envoyés}}',
  'vipAdmin.badgeTelecharge': 'Badge téléchargé',
  'vipAdmin.photo': 'Photo déposée',
  'vipAdmin.visite': 'Visite faite',
  'vipAdmin.renvoyer': 'Renvoyer le courriel',
  'vipAdmin.renvoye': 'Courriel renvoyé à {nom}.',
  'vipAdmin.deconnecter': 'Déconnecter partout',
  'vipAdmin.deconnecterConfirm':
    'Fermer toutes les connexions de {nom} (téléphone, ordinateur, application) ? Il devra de nouveau saisir un code reçu par courriel.',
  'vipAdmin.deconnecte': '{nom} est déconnecté de tous ses appareils.',
  'vipAdmin.revoquer': 'Révoquer',
  'vipAdmin.revoquerConfirm':
    'Révoquer l’invitation de {nom} ? Son lien et ses connexions cesseront aussitôt de fonctionner, et son accompagnant perdra son badge.',
  'vipAdmin.revoque': 'Invitation de {nom} révoquée.',
  'vipAdmin.imprimer': 'Imprimer les badges des confirmés',
  'vipAdmin.imprimerAide': 'Un PDF : chaque invité confirmé et son accompagnant, badge VIP doré.',
  'vipAdmin.import.titre': 'Importer une liste',
  'vipAdmin.import.aide':
    'Une personne par ligne : civilité ; prénom ; nom ; courriel ; titre ; institution. Les adresses déjà invitées sont ignorées.',
  'vipAdmin.import.envoyer': 'Importer et envoyer les invitations',
  'vipAdmin.import.resultat': '{crees} invitation(s) envoyée(s), {ignores} déjà invitée(s), {erreurs} ligne(s) à corriger.',
};
